/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */
import React from "react";
import Canvas from '@antv/f2-react';
import Request from "../../utils/request";
import { Chart, Line, Point, Axis, TextGuide, ImageGuide } from '@antv/f2';
import PropTypes from "prop-types";
import utils from "../../utils/utils";
import "./style.less";

const iamgeGuideW = typeof window != "undefined" && window.screen.width < 410 ? 84 : 94;
const iamgeGuideH = typeof window != "undefined" && window.screen.width < 410 ? 40 : 44;
const iamgeGuideX = typeof window != "undefined" && window.screen.width < 410 ? -11 : -13;
const textGuideY = typeof window != "undefined" && window.screen.width < 410 ? -15.5 : -17;

class PipelinePriceTrend extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      goods_info: {
        goodsName: '',
        name: ''
      },
      price_trend: [],
      rate: [{}],
      min: 0,
      max: 0,
      show: false
    };
  }

  componentDidMount() {
    this.getPriceTrend();
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.props['customAttributes']["data-component-belong"] === 'tab') {
      if (((this.state.show != nextState.show) && nextState.show) || !nextProps.reRender) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  getPriceTrend() {
    let { styleId, styleName, productImage, recommend, finalTimeType = '实时时间', finalTime = '', interval = '3' } = this.props.config.productInfoConig;
    interval = Number(interval);
    Request({
      url: 'https://sh-gateway.shihuo.cn/v4/services/sh-venueapi/lego_goods_price/style',
      method: "get",
      withCredentials: true,
      params: {
        style_id: styleId
      },
    }).then(res => {
      const { status, data } = res.data;
      if (status === 0) {
        const { goods_info, goods_price } = data;
        const list = (goods_price && goods_price.list && goods_price.list[0] && goods_price.list[0].values && goods_price.list[0].values) || [];
        if (finalTimeType === '实时时间') {
          const result = this.getPriceCoord(list, 1, interval);
          const resultSort = JSON.parse(JSON.stringify(result));
          resultSort.sort((a, b) => {
            return a.y - b.y;
          });
          const min = resultSort[0].y;
          const max = resultSort[resultSort.length - 1].y;
          if (styleName) {
            Object.assign(goods_info, {
              goodsName: styleName
            })
          }
          if (productImage) {
            Object.assign(goods_info, {
              pic: productImage
            })
          }
          Object.assign(goods_info, {
            recommend: recommend
          })
          this.setState({
            goods_info,
            price_trend: result,
            rate: goods_price.rate || [{}],
            min,
            max,
            show: true
          })
        } else {
          finalTime = finalTime.replace(/-/g, '/');
          const current_date = parseInt((new Date(`${finalTime} 00:00:00`).getTime()) / 1000);
          const start = list.findIndex(item => item.x == current_date);
          const result = this.getPriceCoord(list, start, interval);
          const resultSort = JSON.parse(JSON.stringify(result));
          resultSort.sort((a, b) => {
            return a.y - b.y;
          });
          const min = resultSort[0].y;
          const max = resultSort[resultSort.length - 1].y;
          if (styleName) {
            Object.assign(goods_info, {
              goodsName: styleName
            })
          }
          if (productImage) {
            Object.assign(goods_info, {
              pic: productImage
            })
          }
          Object.assign(goods_info, {
            recommend: recommend
          })

          this.setState({
            goods_info,
            price_trend: result,
            rate: goods_price.rate || [{}],
            min,
            max,
            show: true
          })
        }
      }
    })
  }

  // 获取价格坐标
  getPriceCoord(list = [], start = 0, interval) {
    const result = [];
    const copy_list = JSON.parse(JSON.stringify(list));
    let last = 0, fill = 0, isLast = false, transitPoint = null, transitIndex = 0;
    for (let index = 0; index < 5; index++) {
      let element = list[start + interval * index];
      if (!element) {
        fill += 1;
        if (!isLast) {
          isLast = true;
          last = index - 1;
          transitPoint = {
            x: Number(copy_list[start + interval * last].x),
            y: copy_list[start + interval * last].y,
            type: '虚点',
            bubble: false
          }
          transitPoint['x'] = this.formatTimes(transitPoint.x);
          transitPoint['y'] = parseFloat(transitPoint.y)
          result.push(transitPoint)
        }
        element = {
          x: Number(copy_list[start + interval * last].x) - 86400 * fill * interval,
          y: copy_list[start + interval * last].y,
          type: '虚点',
          bubble: false
        }
      } else {
        element['type'] = '实点'
        element['bubble'] = true
      }
      element['x'] = this.formatTimes(element.x);
      element['y'] = parseFloat(element.y)
      result.push(element)
    }
    result.reverse();
    return result;
  }

  // 时间戳转日期
  formatTimes(timestamp) {
    let time = new Date(Number(timestamp) * 1000);
    let month = time.getMonth() + 1;
    let day = time.getDate();
    if (month < 10) {
      month = `0${month}`
    }
    if (day < 10) {
      day = `0${day}`
    }
    return `${month}-${day}`;
  }

  handleJump(goods_info = {}) {
    const url = goods_info.detailHref;
    utils.jumpToUrl(this.props.routeParams, url, url, {}, -1, this.props, false, {
      bizExtra: {
        goods_id: goods_info.goodsId,
        style_id: goods_info.id
      }
    });
  }

  render() {
    let { theme = '浅色样式', lineChartBgImage, bubbleBgImage, dateGridColor, lineChartColor, priceFieldColor, bottomPriceColor, bottomBackgroundColor } = this.props.config.styleConfig;
    let { styleName = '' } = this.props.config.productInfoConig;
    const { baseConfig } = this.props.config;
    const { goods_info = {}, price_trend = [], rate = [{}], min, max } = this.state;
    const { yMaxRate = 1, yMinRate = 1 } = rate[0];
    const isDark = theme === '深色样式';
    if (!lineChartBgImage) {
      lineChartBgImage = !isDark 
        ? 'https://static.shihuocdn.cn/admin/files/20221117/d3bc6b7af0770e9970484f3afaa87b85.png'
        : 'https://static.shihuocdn.cn/admin/files/20221117/7545a699adf93380d7f5c2ede7626639.png';
    }
    if (!bubbleBgImage) {
      bubbleBgImage = !isDark
        ? 'https://static.shihuocdn.cn/admin/files/20221116/b1882fec5231102af5454d7e53a4203e.png'
        : 'https://static.shihuocdn.cn/admin/files/20221117/469465adf3076da4c1f331d889e33701.png'
    }
    if (!dateGridColor) {
      dateGridColor = !isDark ? '#999' : '#fff'
    }
    if (!lineChartColor) {
      lineChartColor = !isDark ? '#FF4338' : '#FFDDBC'
    }
    if (!priceFieldColor) {
      priceFieldColor = !isDark ? '#666' : 'rgba(255,255,255,0.8)'
    }
    if (!bottomPriceColor) {
      bottomPriceColor = !isDark ? '#FF4338': '#FFDDBC'
    }
    let sparePriceList1 = [];
    let sparePrice = null
    if (goods_info.price > 1000) {
      sparePrice = utils.priceConversion(goods_info.price, 2);
      if (sparePrice && sparePrice.list) {
        sparePriceList1 = sparePrice.list
      } 
    }
    return (
      <div 
        className="pipeline-priceTrend" 
        {...this.props['customAttributes']}
        style={{
          paddingTop: baseConfig.moduleMarginTop >= 0 ? `${baseConfig.moduleMarginTop}px` : 0,
          marginTop: baseConfig.moduleMarginTop < 0 ? `${baseConfig.moduleMarginTop}px` : 0,
          marginBottom: this.props.showCompMarginBottom ? '8px' : '0px'
        }}
      >
        <div 
          className={!isDark ? 'theme-wrap theme-light' : 'theme-wrap theme-dark'}
          style={{
            height: '100%',
            backgroundColor: bottomBackgroundColor
          }}>
          <div className="panel">
            <div className="product-info">
              <div className="image">
                {goods_info.pic && <img src={utils.formatImgUrl(goods_info.pic, this.props.webpSupport)} alt="" className="image" />}
              </div>
              <div className="info">
                <p className="title">{styleName ? styleName : goods_info.goodsName + ' ' + goods_info.name}</p>
                <div className="description" style={{whiteSpace: 'pre-wrap'}}>
                  {goods_info.recommend}
                </div>
              </div>
            </div>
            <div className="price-trend" style={{backgroundImage: `url(${lineChartBgImage})`}}>
              <div className="cover"></div>
              {
                price_trend.length > 0 && (
                  <Canvas pixelRatio={window.devicePixelRatio}>
                    <Chart data={price_trend} scale={{
                      y: {
                        min: min * yMinRate,
                        max: max * yMaxRate,
                        nice: true
                      }
                    }}>
                      <Axis
                        field="x"
                        tickCount={5}
                        style={
                          {
                            label: {
                              fontSize: 12,
                              textBaseline: 'middle'
                            },
                            line: {
                              lineWidth: 0.5,
                              stroke: dateGridColor,
                              strokeOpacity: 0.3
                            },
                            grid: {
                              lineDash: null,
                              lineWidth: 0.5,
                              stroke: dateGridColor,
                              strokeOpacity: 0.2
                            }
                          }
                        }
                      />
                      <Axis 
                        field="y"
                        tickCount={5}
                        visible={true}
                        style={
                          {
                            label: {
                              fontSize: 0,
                            },
                            line: {
                              lineWidth: 0,
                              stroke: dateGridColor,
                              strokeOpacity: 0.3,
                            },
                            grid: {
                              lineDash: null,
                              lineWidth: 0.5,
                              stroke: dateGridColor,
                              strokeOpacity: 0.2
                            }
                          }
                        }
                      />
                      <Line 
                        x="x"
                        y="y"
                        color={lineChartColor}
                        style={{lineWidth: 1}}
                        shape={{
                          field: 'type',
                          callback: (type) => {
                            if (type === '实点') {
                              return 'line';
                            } else {
                              return 'dash';
                            }
                          },
                        }}/>
                      <Point x="x" y="y" color={lineChartColor} size={2} />
                      {bubbleBgImage && price_trend.map((item, index) => {
                        if (!item.bubble) {
                          return null;
                        }
                        return (
                          <ImageGuide
                            key={`ImageGuide-${index}`}
                            records={[item]}
                            src={bubbleBgImage}
                            attrs={{
                              width: iamgeGuideW,
                              height: iamgeGuideH
                            }}
                            offsetY={-15}
                            // offsetX={iamgeGuideX}
                          />
                        );
                      })}
                      {price_trend.map((item, index) => {
                        let { y } = item;
                        let offsetX = 0, fontSize = 0;
                        if (y < 100) {
                          if (window.screen.width < 410) {
                            offsetX = -12;
                            fontSize = 22;
                          } else {
                            offsetX = -13;
                            fontSize = 23;
                          }
                        } else if (y >= 100 && y < 1000) {
                          if (window.screen.width < 410) {
                            offsetX = -13;
                            fontSize = 22;
                          } else {
                            offsetX = -15;
                            fontSize = 23;
                          }
                        } else if (y >= 1000 && y < 10000) {//万
                          if (window.screen.width < 410) {
                            offsetX = -15;
                            fontSize = 22;
                          } else {
                            offsetX = -17;
                            fontSize = 23;
                          }
                        } else if (y >= 10000 && y < 100000) {//10万
                          if (window.screen.width < 410) {
                            offsetX = -18;
                            fontSize = 20;
                          } else {
                            offsetX = -20;
                            fontSize = 22;
                          }
                        } else if (y >= 100000 && y < 1000000){//100万
                          if (window.screen.width < 410) {
                            offsetX = -17;
                            fontSize = 17;
                          } else {
                            offsetX = -20;
                            fontSize = 19;
                          }
                        } else if (y >= 1000000 && y < 10000000){//1000万
                          if (window.screen.width < 410) {
                            offsetX = -19;
                            fontSize = 16;
                          } else {
                            offsetX = -20.5;
                            fontSize = 18;
                          }
                        } else if (y >= 10000000 && y < 100000000){//1亿
                          if (window.screen.width < 410) {
                            offsetX = -19;
                            fontSize = 15;
                          } else {
                            offsetX = -21;
                            fontSize = 16;
                          }
                        }else if (y >= 100000000) {//超过1亿
                          if (window.screen.width < 410) {
                            offsetX = -18;
                            fontSize = 20;
                          } else {
                            offsetX = -20;
                            fontSize = 22;
                          }
                        } else {
                          if (window.screen.width < 410) {
                            offsetX = -19;
                            fontSize = 14;
                          } else {
                            offsetX = -21;
                            fontSize = 14;
                          }
                        }

                        if (!item.bubble) {
                          return null;
                        }
                        let superMillionList = utils.truncateDecimals(y, 2, 10000 * 10000);
                        let sparePriceList = [];
                        if (superMillionList.length > 0) {//判断是否是超过亿
                          sparePriceList = superMillionList
                        } else {
                          sparePriceList = utils.truncateDecimals(y, 2)
                        }
                        if (sparePriceList.length == 1) {//表示整数
                          offsetX += 6
                        }
                        return (
                          <TextGuide
                            key={`TextGuide-${index}`}
                            records={[item]}
                            content={`¥${sparePriceList.length > 0 ? (sparePriceList[0] + (sparePriceList.length > 1 ? '.' + (sparePriceList[1] || 0) : '') + (superMillionList.length > 0 ? '亿' : '万')): y}`}
                            style={{
                              fill: priceFieldColor,
                              fontSize: fontSize + 'px',
                              fontFamily: 'PingFangSC-Medium, PingFang SC'
                            }}
                            offsetY={textGuideY}
                            offsetX={offsetX}
                          />
                        );
                      })}
                    </Chart>
                  </Canvas>
                )
              }
            </div>
          </div>
          <div className="action-btn">
            <div className="price" style={{color: bottomPriceColor}}>
              当前价
              <p>
                <span style={{fontSize: '14px'}}>¥</span>
                <span style={{fontSize: '20px'}}>{sparePriceList1.length > 0 ? sparePriceList1[0] : goods_info.price}</span>
                {sparePriceList1.length > 1 ? (
                 <span style={{fontSize: '15px'}}>.{(sparePriceList1[1] || 0)}</span>
                ): null}
                {
                 sparePrice && sparePrice.unit ? <span style={{fontSize: '14px'}}>{sparePrice.unit}</span> : null
                }
              </p>
            </div>
            <img src={!isDark ? 'https://static.shihuocdn.cn/admin/files/20221028/fc6a818516614dff9285280456f8448e.png' : 'https://static.shihuocdn.cn/admin/files/20221115/622fbc9a30ce7760757990f43304addc.png'} alt="" onClick={() => this.handleJump(goods_info)} />
          </div>
        </div>
      </div>
    )
  }
}

PipelinePriceTrend.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelinePriceTrend };
export default PipelinePriceTrend;



// WEBPACK FOOTER //
// ./components/pipeline-priceTrend/index.js